import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class AccountTransactionService {

  private baseApiUrl: string;

  constructor(
    configurationService: ConfigurationService,
    private httpClient: HttpClient
  ) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  
 


 createPayment(payload: any): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + 'paymenttransaction/payment', payload).pipe(
  
      map((res:any) =>res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
  }
    